import React from 'react'
import closeIcon from "../../../src/assets/images/Icons/close_icon.svg";
import { IoMdClose } from "react-icons/io";

const ErrorCodePopup = (props) => {
    const { onClose, message } = props;
    return (
        <>
            <div className='errorcode_overlay'></div>

            <div className="errorcode_modal">
                <div className="errorcode_modal_close" onClick={onClose}>
                    {/* <img src={closeIcon} alt="" /> */}
                    <IoMdClose className="btnclose"/>
                    </div>
                <p>
                    {message}
                </p>
                <div className="error_poupcontent_btns">
                    <button className="btn" onClick={onClose}>
                        OK
                    </button>
                </div>
            </div>


        </>
    )
}
export default ErrorCodePopup